/// <reference types="arcgis-js-api" />

import esriConfig from "esri/config";

const DEFAULT_WORKER_URL = "https://js.arcgis.com/4.22/";

esriConfig.request.interceptors?.push({
  urls: /MapServer\/83/,
  before(params) {
    if (params.url.includes("query")) {
      params.requestOptions.query.f = 'json';
    }
  }
}); 

http://localhost/IROADS/proxy.ashx?https://gisdev.dot.illinois.gov/arcgis/rest/services/IROADS/IROADS_Public/MapServer/83/query?outFields=*&spatialRel=esriSpatialRelIntersects&where=INVENTORY%20%3D%20%27084%20%2010055%20000000%27

esriConfig.workers.loaderConfig = {
  packages: [
    { name: "esri", location: DEFAULT_WORKER_URL + "esri" },
    { name: "moment", location: DEFAULT_WORKER_URL + "moment" },
    {
      name: "cldrjs",
      location: DEFAULT_WORKER_URL + "cldrjs",
      main: "dist/cldr"
    },
    {
      name: "globalize",
      location: DEFAULT_WORKER_URL + "globalize",
      main: "dist/globalize"
    },
    {
      name: "maquette",
      location: DEFAULT_WORKER_URL + "maquette",
      main: "dist/maquette.umd"
    },
    {
      name: "maquette-css-transitions",
      location: DEFAULT_WORKER_URL + "maquette-css-transitions",
      main: "dist/maquette-css-transitions.umd"
    },
    {
      name: "maquette-jsx",
      location: DEFAULT_WORKER_URL + "maquette-jsx",
      main: "dist/maquette-jsx.umd"
    },
    { name: "tslib", location: DEFAULT_WORKER_URL + "tslib", main: "tslib" }
  ]
} as any;
